import { render, staticRenderFns } from "./JdsNavigatorHeading.vue?vue&type=template&id=c355980a&scoped=true&"
import script from "./JdsNavigatorHeading.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorHeading.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNavigatorHeading.vue?vue&type=style&index=0&id=c355980a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c355980a",
  null
  
)

export default component.exports